import { render, staticRenderFns } from "./RatioContainer.vue?vue&type=template&id=68fec2aa&scoped=true&lang=pug&functional=true&"
import script from "./RatioContainer.vue?vue&type=script&lang=js&"
export * from "./RatioContainer.vue?vue&type=script&lang=js&"
import style0 from "./RatioContainer.vue?vue&type=style&index=0&id=68fec2aa&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../.yarn/$$virtual/vue-loader-virtual-a9dd69dad6/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "68fec2aa",
  null
  
)

export default component.exports